import { Component, inject, input, ViewChild } from '@angular/core';
import { FileUpload, FileUploadModule } from '@openng/optimus-ui/fileupload';
import { TranslatePipe } from '@ngx-translate/core';
import { DefaultCategoryTypeEnum } from '@libs/types/src/file-manager/types/default-category.type';
import { ExternalType } from '@libs/types/src/file-manager/enum/external-type.enum';
import { UserUploadCertificateStore } from './user-upload-certificate.store';
import { ButtonComponent } from '../../../kit/button/button.component';
import { UserSecretTypeEnum } from '@libs/types/src/user/enum/user-secret-type.enum';
import { uploadFile } from '../../../../utils/files.utils';

@Component({
    selector: 'app-user-upload-certificate',
    imports: [
        ButtonComponent,
        FileUploadModule,
        TranslatePipe,
    ],
    templateUrl: './user-upload-certificate.component.html',
    styleUrl: './user-upload-certificate.component.scss',
    providers: [UserUploadCertificateStore],
})
export class UserUploadCertificateComponent {
    public readonly store = inject(UserUploadCertificateStore);

    @ViewChild('fuKval1') fileUploadKval1!: FileUpload;
    @ViewChild('fuKval2') fileUploadKval2!: FileUpload;

    public userId = input<string | null>(null);

    async save() {
        if (
            this.fileUploadKval1.files?.length &&
            this.fileUploadKval2.files?.length &&
            this.userId()
        ) {
            const file1 = this.fileUploadKval1.files[0];
            const file2 = this.fileUploadKval2.files[0];
            const uploadFile1 = await this.store.api.getPresignedUrl({
                name: file1.name,
                categoryCode: DefaultCategoryTypeEnum.CERTIFICATES,
                owner: 'user_cert_qual_public' + this.userId(),
                replace: true,
                note: null,
                kind: null,
                date: new Date(),
                accesses: [
                    {
                        externalType: ExternalType.user,
                        externalId: this.userId()!,
                    },
                ],
            });

            await uploadFile({
                url: uploadFile1.url,
                file: file1,
            });

            const result1 = await this.store.api.confirmFileUpload({
                id: uploadFile1.id,
            });

            const uploadFile2 = await this.store.api.getPresignedUrl({
                name: file2.name,
                categoryCode: DefaultCategoryTypeEnum.CERTIFICATES,
                owner: 'user_cert_qual_private' + this.userId()!,
                replace: true,
                note: null,
                kind: null,
                date: new Date(),
                accesses: [
                    {
                        externalType: ExternalType.user,
                        externalId: this.userId()!,
                    },
                ],
            });

            await uploadFile({
                url: uploadFile2.url,
                file: file2,
            });

            const result2 = await this.store.api.confirmFileUpload({
                id: uploadFile2.id,
            });

            const res = await this.store.api.createUserSecret({
                type: UserSecretTypeEnum.QUAL_CERT,
                publicSecret: result1.path,
                privateSecret: result2.path,
                userId: this.userId()!,
                validTo: null,
            });
            return res.ok;
        }
        return false;
    }
}
